import EnvMap from "../../props/EnvMap"
import LightOne from "./props/lights"
import ActeOneModels from "./models/ActeOneModels"
import CameraOne from "./props/camera"
import Orchestreur from "../../Orchestreur"
import ContentOne from './props/ContentOne'
import { useFrame } from '@react-three/fiber'
import { useActsStore } from '../../store/useActsStore'



export default function ActeOne({ progress }) {


    return (
        <>
            <Orchestreur
                id={0}
                progress={progress}
                range={{ start: 0.00, end: 0.35 }}
                Camera={CameraOne}
                Env={EnvMap}
                Lights={LightOne}
                Models={ActeOneModels} 
                Overlay={ContentOne}
            >
            </Orchestreur>


        </>
    )
}
